import React, { useState } from 'react';

const Seat = ({ seatId, status, bookedBy, onSelectSeat, isAisle }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    if (status !== 'booked' && !isAisle) {
      onSelectSeat(seatId);
    }
  };

  let seatClass = 'seat';
  if (isAisle) seatClass += ' aisle';
  else if (status === 'selected') seatClass += ' selected';
  else if (status === 'booked') seatClass += ' booked';

  const redChairImage = require('../assets/avatars/redchair.png');

  return (
    <div
      className={seatClass}
      onClick={handleClick}
      aria-label={`Seat ${seatId}, Status: ${isAisle ? 'aisle' : status}`}
      role="button"
      tabIndex={status === 'booked' || isAisle ? -1 : 0}
      onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick();}}
      onMouseEnter={() => { 
        console.log('Mouse enter on seat:', seatId, 'Status:', status, 'BookedBy:', bookedBy);
        if (status === 'booked' && bookedBy) {
          setShowTooltip(true);
        }
      }}
      onMouseLeave={() => {
        console.log('Mouse leave on seat:', seatId);
        setShowTooltip(false);
      }}
      style={{ position: 'relative' }}
    >
      {!isAisle && (
        <>
          {status === 'available' ? (
            <img
              src={redChairImage}
              alt={`Empty seat ${seatId}`}
              className="seat-chair-icon"
            />
          ) : (
            seatId
          )}
        </>
      )}
      {showTooltip && status === 'booked' && bookedBy && (
        <div className="seat-tooltip">
          Booked by: {bookedBy}
        </div>
      )}
      {/* Debug: Show tooltip for all seats to test CSS */}
      {showTooltip && (
        <div className="seat-tooltip" style={{background: 'red'}}>
          DEBUG: {seatId} - {status} - {bookedBy || 'No name'}
        </div>
      )}
    </div>
  );
};

export default Seat;
